export default {
  required: (value) => {
    if (value === "" || value === null || value === undefined)
      return "This field is required!";
    else return !!value;
  },

  validEmail: (value) => {
    if (value) {
      if (value.indexOf("@") > -1 && value.indexOf(".") > -1) return !!value;
      return "Please enter a valid email address!";
    }else if (value === ""||value === null) {
      return "This field is required!";
    }
    return !!value;
  },

  validPassword: (value) => {
    if (value) {
      if (value.length >= 6) return !!value;
      return "Password must be at least 6 letters.";
    }
    return !!value;
  },
  checkCoupoun: (value) => {
    if (value === "" || value === null || value === undefined)
      return "कृपया कूपन कोड ढाले";
    else return !!value;
  },
  validPhoneNumber: (value) => {
    console.log('value',value);
    if (value) {
      if (value === null || value === undefined || value.length === 10) {
        return !!value;
      }
      return "Mobile Number must be of 10 characters.";
    } else if (value === ""||value === null) {
      return "Mobile Number is required.";
    }
    return !!value;
  },
};
